
export const REJECTION_REASONS_KEYS = [
  'product',
  'inventory',
  'production',
  'artwork',
  'pricing',
  'merchant',
  'fraud',
  'test',
  'quantity',
  'increments',
  'duplicate',
  'address',
  'other'
];

export const REJECTION_EXPECTATIONS_CODE = {
  product: 'validProductConfiguration',
  inventory: 'sufficientinventory',
  production: 'productionCompleted',
  artwork: 'validArtwork',
  pricing: 'pricingIssue',
  merchant: 'merchantCancellation',
  fraud: 'fraudOrder',
  test: 'testOrder',
  quantity: 'minimumQuantity',
  increments: 'quantityIncrements',
  duplicate: 'duplicateOrder',
  address: 'invalidAddress',
  other: 'miscellaneous'
};
